/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ShuffleIcon = /*#__PURE__*/ createSvgIcon(
  'ShuffleIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.078 4.445H18v.97h-4.898a2.935 2.935 0 00-2.374 1.441l-.014.023-2.336 3.118 2.371 3.097.013.02a2.975 2.975 0 002.38 1.401H18v.97h-4.892a3.945 3.945 0 01-3.157-1.838l-2.79-3.644L9.907 6.34a3.905 3.905 0 013.16-1.894h.012z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.73 10.5H2v-1h5.73v1zM17.294 15l-2.638-2.647.708-.706L18.706 15l-3.342 3.353-.708-.706L17.294 15zM17.294 4.982l-2.637-2.628.706-.708 3.343 3.332-3.34 3.374-.711-.704 2.64-2.666z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ShuffleIcon;
